module.exports = __webpack_public_path__ + "img/6.dc6e8f21.webp";